export default __webpack_public_path__ + "static/media/Cancel.37477ac1.webp";